import * as React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

import { LargeBlocLoader } from 'modules/shared-cms/components';
import { TitleBlocLoader } from 'modules/shared-cms-advanced/components';

export const SignLoader: React.FC = React.memo(() => {
    return (
        <React.Fragment>
            <Placeholder style={{ maxWidth: '100%', textAlign: 'center' }}>
                <Placeholder.Header>
                    <Placeholder.Line />
                </Placeholder.Header>
            </Placeholder>
            <TitleBlocLoader />
            <Placeholder style={{ maxWidth: '100%', textAlign: 'center' }}>
                <Placeholder.Header>
                    <Placeholder.Line />
                </Placeholder.Header>
            </Placeholder>
            <LargeBlocLoader />
            <LargeBlocLoader />
            <Placeholder style={{ maxWidth: '100%', textAlign: 'center' }}>
                <Placeholder.Header>
                    <Placeholder.Line />
                </Placeholder.Header>
            </Placeholder>
            <TitleBlocLoader />
        </React.Fragment>
    );
});
